module.exports = __webpack_public_path__ + "img/notas.f8319229.png";